
    <ngx-loading-bar [includeSpinner]="false" [color]="'#4ba7fa'"></ngx-loading-bar>

    <app-loading-global></app-loading-global>
    <router-outlet></router-outlet>
